<ng-container *ngIf="!loader">

  <div class="form-horizontal">
    <div class="col-3">
      <div class="form-group">
        <label class="label" for="numberSpot">Номер пятна</label>
        <input class="form-control blink2" type="text" [(ngModel)]="spotObject.number"
          [ngClass]="spotObject?.number?.length > 0 ? 'blink1': 'blink2'" (ngModelChange)="spotObject.number = $event"
          id="numberSpot" placeholder="Номер пятна">
      </div>

      <div class="form-group">
        <label class="label" for="numberHome">Номер дома</label><br>
        <input class="form-control blink2" type="text" [(ngModel)]="spotObject.homeNumber"
          [ngClass]="spotObject?.homeNumber?.length > 0 ? 'blink1' : 'blink2'"
          (ngModelChange)="spotObject.homeNumber = $event" id="numberHome" placeholder="Номер дома">
      </div>

      <div class="form-group">
        <label class="label" for="numberSteps">Кол-во этажей</label>
        <input class="form-control blink2" type="number" [(ngModel)]="spotObject.floors"
          [ngClass]="spotObject?.floors > 0 ? 'blink1' : 'blink2'" (ngModelChange)="changedFloor($event)"
          id="numberSteps" placeholder="Кол-во этажей" min="0">
      </div>

      <div class="col-2 text-center">
        <label class="container-checkbox">Мансарда
          <input type="checkbox" [(ngModel)]="spotObject.hasMansard" (ngModelChange)="spotObject.hasMansard = $event">
          <span class="checkmark"></span>
        </label>
      </div>

      <div class="typic-btn">
        <div class="btn btn-light" (click)="openTypicalFloor()">Типовые этажи</div>
      </div>

    </div>

    <div class="col-3 checkbox-container">
      <div class="btn btn-light" *ngFor="let rooms of buildingRoomTypes" (click)="rooms.modal = true">
        {{rooms.title}}
      </div>
      <div class="btn btn-light" (click)="openFinishTemplate()">Шаблон для типа отделки</div>
      <div class="btn btn-light" (click)="wallModal = true">Конструктив</div>
    </div>

    <div class="col-2">
      <div class="add-block btn" (click)="openAddBlock()">Добавить блок </div>
      <div class="add-block btn" (click)="duplicateBuilding()"> Типовое пятно </div>
      <ng-container *ngIf="addBlocModal">
        <div class="popup">
          <div>
            <input type="text" class="edit-date1" [(ngModel)]="block.blockNumber" />
          </div>
          <div class="buttons">
            <div class="btn-accept" (click)="addBlock();">Применить</div>
            <div class="btn-decline" (click)="cancelAddBlock()">Отменить</div>
          </div>
        </div>
      </ng-container>
      <div>
        <div class="blocks" *ngFor="let block of blocks">
          <div class="btn block-btn">
            <span class="item-1" (click)="openBlock(block)">{{block.title}} {{block.blockNumber}}</span>
            <span class="item-close" (click)="delBlock(block.id)"></span>
          </div>
        </div>
      </div>
    </div>

    <app-modal-window *ngIf="editBlocModal == true" [title]="'Блок '+ selectedBlock.blockNumber"
      [visible]="editBlocModal" [scrollbar]="true" (close)="editBlocModal = $event" [width]="500" [height]="300">
      <app-editblock [spotID]="spotObject?.id" [block]="selectedBlock"></app-editblock>
    </app-modal-window>

    <div class="col-2 radio-container">
      <label class="container-checkbox" *ngFor="let rank of spotObject?.spotRanks">
        {{rank.title}}
        <input type="checkbox" name="spot_class" [(ngModel)]="rank.checked" (click)="changeClass(rank)">
        <span class="checkmark markRadio"></span>
      </label>
    </div>

    <div class="col-2">
      <table>
        <thead>
          <th>Кол-во квартир</th>
          <th>Всего</th>
        </thead>
        <tbody class="info-table-container">
          <tr *ngFor="let floor of spotObject?.countRooms">
            <td>{{floor.roomCountTitle}}</td>
            <td>
              {{floor.flatCount ? floor.flatCount : '-'}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="wall-materials-content" *ngIf="materialIsChecked">
    <div class="wall-materials">
      <ul class="list-wall-materials">
        <ng-container *ngFor="let types of spotObject?.wallMaterials">
          <ng-container *ngFor="let type of types.wall_material">
            <li *ngIf="type.checked">
              {{type.title}}
              <span class="item-close" (click)="type.checked = !type.checked"></span>
            </li>
          </ng-container>
        </ng-container>
      </ul>
    </div>
  </div>

  <div class="add-appartment-content">
    <div class="btn btn-apply" (click)="addFlats()">
      <ng-container *ngIf="!addFlatLoading"> Добавить квартиры </ng-container>
      <ng-container *ngIf="addFlatLoading">
        <div class="loading"></div>
      </ng-container>
    </div>
  </div>

  <!-- Add appartment Modal -->
  <app-modal-window *ngIf="appartmentModal" [title]="'Добавить квартиры'" [visible]="appartmentModal" [scrollbar]="true"
    (close)="closeAppartmentModal($event)">
    <app-add-appartment [spotObjectAddAppartments]="spotObject" [floorsCommercial]="floorsCommercial" [countOfOpen]="countOfOpen" [changeAppartment]="changeAppartment">
    </app-add-appartment>
  </app-modal-window>

  <!-- Wall Material appartment Modal -->
  <app-modal-window *ngIf="wallModal" [title]="'Материал стен'" [visible]="wallModal" [height]="450" [width]="900"
    [scrollbar]="false" (close)="wallModal = $event">
    <app-wall-material [spotObjectAddAppartments]="spotObject" [isOneChecked]="materialIsChecked"
      (isOneChange)="materialIsChecked = $event"></app-wall-material>
  </app-modal-window>

  <!-- Flat Modal -->
  <app-modal-window *ngIf="flatFlag" [title]="appModalWindowTitle" [visible]="flatFlag" [height]="720"
    (close)="flatFlag = $event">
    <app-flats-modal [otherRoomFlag]="otherRoomFlag" [buildingId]="spotObject?.id" [flatId]="selectedFlatId"
      [flat]="selectedFlat" [furnishTemplate]="furnishTemplate" (confirmEventTwo)="reloadData($event);"
      [spotForm]="spotForm"></app-flats-modal>
  </app-modal-window>

  <!-- Типовые этажи -->
  <app-modal-window *ngIf="typicFloor" [title]="'Типовые этажи'" [visible]="typicFloor" [height]="450" [width]="500"
    [scrollbar]="false" (close)="cancelTypicFloors()">
    <div class="typic-floor-block">
      <div class="typic-floor-content">
        <div class="left-side">
          <div class="flex-row">{{'От:'}}</div>
          <div class="flex-row" *ngFor="let t of typicFloors;">
            <div class="floor">{{t.floorTitle}}</div>
            <input type="radio" [value]="t.floorID" [(ngModel)]="selectedTypicFloorId" (change)="radioChange()">
          </div>
        </div>
        <div class="right-side">
          <div class="flex-row">{{'Какой'}}</div>
          <div class="flex-row" *ngFor="let t of typicFloors2;">
            <div class="floor">{{t.floorTitle}}</div>
            <input type="checkbox" [value]="t.floorID" [checked]="t.isChecked" (change)="t.isChecked = !t.isChecked">
          </div>
        </div>
      </div>
      <div class="typic-floor-buttons">
        <div class="btn btn-apply" (click)="applyTypicFloors()">Подтвердить</div>
        <div class="btn btn-cancel" (click)="cancelTypicFloors()">Отменить</div>
      </div>
    </div>
  </app-modal-window>

  <!-- Building Rooms premises appartment Modal -->
  <ng-container *ngFor="let modals of buildingRoomTypes">
    <app-modal-window *ngIf="modals?.modal" [title]="modals?.title" [visible]="modals?.modal" [height]="395"
      [width]="900" [scrollbar]="false" (close)="modals.modal = $event; ">
      <app-commercial-premises *ngIf="modals?.title === 'Коммерческие помещения'"
        [spotObjectAddAppartments]="spotObject"></app-commercial-premises>
      <app-auxiliary-premises *ngIf="modals?.title === 'Вспомогательные помещения'"
        [spotObjectAddAppartments]="spotObject"></app-auxiliary-premises>
      <app-parking *ngIf="modals?.title === 'Парковка'" [spotObjectAddAppartments]="spotObject"></app-parking>
    </app-modal-window>
  </ng-container>

  <!-- Template Furnish List -->
  <app-modal-window *ngIf="furnishModal" [title]="appModalWindowTitle" [visible]="furnishModal" [width]="650"
    [height]="620" (close)="furnishModal = $event">
    <app-typeofot [furnishListEx]="furnishTemplate" (selectedfurnishListEx)="getReturnFurnishes($event)"></app-typeofot>
  </app-modal-window>

  <div class="appartment-content">
    <div class="appartment-scheme">
      <div class="table-body" *ngIf="spotObject?.floors > 0">
        <table>
          <thead>
            <tr>
              <th>Квартир</th>
              <th>Площадь</th>
              <th>Этаж</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let rooms of spotObject?.auxiliaryRooms">
              <tr class="th-other" *ngIf="rooms.id === 203 && rooms.checked">
                <th>{{rooms.placeCount ? rooms.placeCount : '-'}}</th>
                <th>{{rooms.area ? rooms.area : '-'}}</th>
                <th>{{rooms.title}}</th>
              </tr>
            </ng-container>
            <tr class="th-other" *ngIf="spotObject?.hasMansard">
              <th>{{spotObject.mansardRooms.placeCount ? spotObject.mansardRooms.placeCount : '-'}}</th>
              <th>{{spotObject.mansardRooms.area ? spotObject.mansardRooms.area : '-'}}</th>
              <th>Мансарда</th>
            </tr>
            <tr class="th-floors" *ngFor="let floor of spotObject?.apartmentCount; let i = index">
              <th>{{floor.flatCount ? floor.flatCount : '-'}}</th>
              <th>{{floor.flatArea ? floor.flatArea : '-' }}</th>
              <th>{{floor.floorID}}</th>
            </tr>

            <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
              <tr class="th-other"
                *ngIf="parking.checked && parking.id === 30402 && !commercialSecondFloor">
                <th>{{parking.placeCount ? parking.placeCount : '-'}}</th>
                <th>{{parking.area ? parking.area : '-'}}</th>
                <th>{{parking.title}}</th>
              </tr>
            </ng-container>

            <!-- (commercial.title === '2 - Встроенные' || commercial.title === '2 - Встроенно-пристроенные') -->
            <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
              <tr class="th-other" *ngIf="commercial.checked && (commercial.id === 10102 || commercial.id === 10302)">
                <!-- <th>{{commercial.placeCount ? commercial.placeCount : '-'}}</th> -->
                <th>-</th>
                <th>{{secondFloorArea ? secondFloorArea : '-'}}</th>
                <th>{{commercial.title}}</th>
              </tr>
            </ng-container>

            <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
              <tr class="th-other"
                *ngIf="parking.checked && parking.id === 30401 && !commercialFirstFloor">
                <th>{{parking.placeCount ? parking.placeCount : '-'}}</th>
                <th>{{parking.area ? parking.area : '-'}}</th>
                <th>{{parking.title}}</th>
              </tr>
            </ng-container>

            <!-- (commercial.title === '1 - Встроенные' || commercial.title === '1 - Встроенно-пристроенные') -->
            <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
              <tr class="th-other" *ngIf="commercial.checked && (commercial.id === 10101 || commercial.id === 10301)">
                <!-- <th>{{commercial.placeCount ? commercial.placeCount : '-'}}</th> -->
                <th>-</th>
                <th>{{firstFloorArea ? firstFloorArea : '-'}}</th>
                <th>{{commercial.title}}</th>
              </tr>
            </ng-container>


            <!-- Пристроенные -->
            <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
              <tr class="th-other" *ngIf="commercial.checked && commercial.id == 102">
                <th>{{commercial.placeCount ? commercial.placeCount : '-'}}</th>
                <th>{{commercial.area ? commercial.area : '-'}}</th>
                <th>{{commercial.title}}</th>
              </tr>
            </ng-container>
            <!-- <ng-container *ngFor="let commercial of spotObject.commercialRooms; let i = index;">
              <tr class="th-other" *ngIf="commercial.checked && !floorsCommercial">
                <th>{{commercial.placeCount ? commercial.placeCount : '-'}}</th>
                <th>{{commercial.area ? commercial.area : '-'}}</th>
                <th>{{commercial.title}}</th>
              </tr>
            </ng-container> -->

  

            <ng-container *ngFor="let rooms of spotObject?.auxiliaryRooms">
              <tr class="th-other" *ngIf="rooms.title === 'Цокольный этаж' && rooms.checked">
                <th>{{rooms.placeCount ? rooms.placeCount : '-'}}</th>
                <th>{{rooms.area ? rooms.area : '-'}}</th>
                <th>{{rooms.title}}</th>
              </tr>
            </ng-container>
            <ng-container *ngFor="let rooms of spotObject?.auxiliaryRooms">
              <tr class="th-other" *ngIf="rooms.title === 'Подвал' && rooms.checked">
                <th>{{rooms.placeCount ? rooms.placeCount : '-'}}</th>
                <th>{{rooms.area ? rooms.area : '-'}}</th>
                <th>{{rooms.title}}</th>
              </tr>
            </ng-container>

             <!-- Паркинг -->
             <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
              <tr class="th-other"
                *ngIf="parking.checked && (parking.id !== 30401 && parking.id !== 30402 && parking.id !== 304)">
                <th>{{parking.placeCount ? parking.placeCount : '-'}}</th>
                <th>{{parking.area ? parking.area : '-'}}</th>
                <th>{{parking.title}}</th>
              </tr>
            </ng-container>
          </tbody>
        </table>

        <div class="box-right">
          <div class="box-right__inner">
            <div class='title-stage'>
              <div
                attr.colspan="{{spotObject?.apartmentScheme?.length > 0 ? spotObject?.apartmentScheme[0].length : 6}}">
                <span>Пятно {{spotObject?.number}} / Д {{spotObject.homeNumber}}</span>
                <span>Квартир {{spotObject.apartment_number}}</span>
              </div>
            </div>
            <ng-container>
              <div class="other-rooms"
                *ngIf="spotObject?.auxiliaryRooms.length > 0 && spotObject?.auxiliaryRooms[2].checked">
                <div class="row row-1"
                  attr.colspan="{{spotObject?.apartmentScheme?.length > 0 ? spotObject?.apartmentScheme[0].length : 6}}"
                  (click)="openOtherRoom(spotObject?.auxiliaryRooms[2])">
                </div>
              </div>

              <div class="other-rooms" *ngIf="spotObject?.hasMansard">
                <div class="row row-1"
                  attr.colspan="{{spotObject?.apartmentScheme?.length > 0 ? spotObject?.apartmentScheme[0].length : 6}}"
                  (click)="openOtherRoom(spotObject?.mansardRooms)">
                </div>
              </div>
            </ng-container>

            <div class="floor-row" *ngFor="let floor of obj">
              <div class="floor-row-inner" *ngFor="let flat of floor.flatsArr">
                <div class="flat-box" *ngFor="let f of flat.info; let index = index"
                  (click)="f.flatConfigurationID?chooseFlat(f):''">
                  <div class="flat-box__inner" [ngClass]="{'green' : f.isSale, 'cursor':f.flatConfigurationID}">
                    <div class="hover-text" *ngIf="f.isCornerFlat">Угловая квартира</div>
                    <div class="triangle" *ngIf="f.isCornerFlat"></div>
                    <span class="room">{{f.roomCountID?f.roomCountID:'-'}}
                      {{f.roomCountID?'ком.':''}}
                    </span>
                    <span>{{f.flatNumber?'':''}} {{f.flatNumber?'№':''}}{{f.flatNumber?f.flatNumber:'-'}}</span>
                    <span class="room">{{f.flatArea | number}}
                      {{f.flatArea?'кв.м.':''}}
                      {{f.flatArea==0?'кв.м.':''}}
                    </span>
                    <span class="item-close" *ngIf="f.roomCountID && !f.isSale"
                      (click)="deleteFlat(spotObject.id,floor.floorID, f.roomCountID, flat.info, index, f.flatID, f); $event.stopPropagation();"></span>
                  </div>
                </div>
              </div>
            </div>

            <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
              <div class="parking"
                *ngIf="parking.checked && parking.id === 30402 && !commercialSecondFloor">
                <div class="row"  (click)="openOtherRoom(parking)">
                  <span>{{parking.placeCount ? parking.placeCount + ' мест' : '-'}}</span>
                  <span>{{parking.area ? parking.area + ' кв.м' : '-'}}</span>
                </div>

                <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
                    <div *ngIf="commercial.checked && (commercial.title === '2 - Встроенные' || commercial.title === '2 - Встроенно-пристроенные')" style="display: flex; width:100%;">
                        <div class="label">{{commercial.title}}</div>
                        <div class="row"
                        (click)="openOtherRoom(commercial)">
                        <span>{{commercial.placeCount ? commercial.placeCount + ' мест' : '-'}}</span>
                            <span>{{commercial.area ? commercial.area + ' кв.м' : '-'}}</span>
                      </div>
                    </div>
                  </ng-container>

              </div>
            </ng-container>

            <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
              <div class="parking floor-embedded__in"
                *ngIf="commercial.checked && (commercial.title === '2 - Встроенные' || commercial.title === '2 - Встроенно-пристроенные')">

                <div class="row" 
                  (click)="openOtherRoom(commercial)">
                  <span>{{commercial.placeCount ? commercial.placeCount + ' мест' : '-'}}</span>
                      <span>{{commercial.area ? commercial.area + ' кв.м' : '-'}}</span>
                </div>

                <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
                    <div *ngIf="parking.checked && parking.id === 30402" style="display: flex; width:100%;">
                        <div class="label">{{parking.title}}</div>
                      <div class="row" 
                        (click)="openOtherRoom(parking)">
                        <span>{{parking.placeCount ? parking.placeCount + ' мест' : '-'}}</span>
                        <span>{{parking.area ? parking.area + ' кв.м' : '-'}}</span>
                      </div>
                    </div>
                  </ng-container>

              </div>
            </ng-container>

            <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
              <div class="parking"
                *ngIf="parking.checked && parking.id === 30401 && !commercialFirstFloor">
                <div class="row"
                  (click)="openOtherRoom(parking)">
                  <span>{{parking.placeCount ? parking.placeCount + ' мест' : '-'}}</span>
                    <span>{{parking.area ? parking.area + ' кв.м' : '-'}}</span>
                </div>
                <!-- attr.colspan="{{spotObject.apartmentScheme?.length > 0 ? spotObject.apartmentScheme[0].length : 6}}" -->
                <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
                    <div *ngIf="commercial.checked && (commercial.title === '1 - Встроенные' || commercial.title === '1 - Встроенно-пристроенные')" style="display: flex; width:100%;" >
                        <div class="label">{{commercial.title}} </div>
                        <div class="row" (click)="openOtherRoom(commercial)">
                        <span>{{commercial.placeCount ? commercial.placeCount + ' мест' : '-'}}</span>
                            <span>{{commercial.area ? commercial.area + ' кв.м' : '-'}}</span>
                      </div>
                    </div>
                  </ng-container>

              </div>
            </ng-container>

            <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
              <div class="parking floor-embedded__in"
                *ngIf="commercial.checked && (commercial.title === '1 - Встроенные' || commercial.title === '1 - Встроенно-пристроенные')">

                <div class="row"
                  (click)="openOtherRoom(commercial)">
                  <span>{{commercial.placeCount ? commercial.placeCount + ' мест' : '-'}}</span>
                      <span>{{commercial.area ? commercial.area + ' кв.м' : '-'}}</span>
                </div>

                <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
                  <div *ngIf="parking.checked && parking.id === 30401" style="display: flex; width:100%;">
                      <div class="label">{{parking.title}}</div>
                    <div class="row"
                      (click)="openOtherRoom(parking)">
                      <span>{{parking.placeCount ? parking.placeCount + ' мест' : '-'}}</span>
                      <span>{{parking.area ? parking.area + ' кв.м' : '-'}}</span>
                    </div>
                  </div>
                </ng-container>


              </div>
            </ng-container>

            

            <ng-container *ngFor="let commercial of spotObject?.commercialRooms; let i = index;">
              <div class="other-rooms floor-embedded__in" *ngIf="commercial.checked && commercial.id === 102">
                <div class="row"
                  attr.colspan="{{spotObject?.apartmentScheme?.length > 0 ? spotObject?.apartmentScheme[0].length : 6}}"
                  (click)="openOtherRoom(commercial)">
                </div>
              </div>
            </ng-container>

            <!-- <ng-container *ngFor="let commercial of spotObject.commercialRooms; let i = index;">
              <div class="other-rooms" *ngIf="commercial.checked && !floorsCommercial">
                <div class="row"
                  attr.colspan="{{spotObject.apartmentScheme?.length > 0 ? spotObject.apartmentScheme[0].length : 6}}"
                  (click)="openOtherRoom(commercial)">
                </div>
              </div>
            </ng-container> -->

            

 

            <div class="other-rooms"
              *ngIf="this.spotObject?.auxiliaryRooms.length > 0 && spotObject?.auxiliaryRooms[0]?.checked">
              <div class="row cursor-pointer"
                attr.colspan="{{spotObject.apartmentScheme?.length > 0 ? spotObject?.apartmentScheme[0]?.length : 6}}"
                (click)="openOtherRoom(spotObject?.auxiliaryRooms[0])">
              </div>
            </div>

            <div class="other-rooms"
            *ngIf="this.spotObject?.auxiliaryRooms?.length > 0 && spotObject?.auxiliaryRooms[1]?.checked">
            <div class="row cursor-pointer"
              attr.colspan="{{spotObject.apartmentScheme?.length > 0 ? spotObject.apartmentScheme[0].length : 6}}"
              (click)="openOtherRoom(spotObject?.auxiliaryRooms[1])">
            </div>
          </div>

          <ng-container *ngFor="let parking of spotObject?.parkingRooms; let i = index;">
            <div class="other-rooms"
              *ngIf="parking.checked && (parking.id !== 30401 && parking.id !== 30402 && parking.id !== 304)">
              <div class="row"
                attr.colspan="{{spotObject?.apartmentScheme?.length > 0 ? spotObject?.apartmentScheme[0]?.length : 6}}"
                (click)="openOtherRoom(parking)">
              </div>
            </div>
          </ng-container>

          </div>
        </div>
      </div>
    </div>
  </div>
  <app-modal-window *ngIf="openConfirmDialog" [title]="'Удалить квартиру'" [visible]="openConfirmDialog"
    (close)="openConfirmDialog = $event" [width]="550" [height]="380">
    <div class="confirm">
      <div class="body">
        <div class="warning">
          <img src="assets/svg-icons/warning.svg" alt="">
        </div>
        <div class="text main"> Вы уверены, что хотите удалить квартиру?</div>
        <div class="text secondary">
          В случае выбора "ДА", дальнейшее восстановление квартиры невозможно!
        </div>
      </div>
      <div class="btns">
        <div class="btn btn-apply" (click)="deleteFlatEx('yes')">ДА</div>
        <div class="btn btn-cancel" (click)="deleteFlatEx('no')">НЕТ</div>
      </div>
    </div>
  </app-modal-window>

</ng-container>
<ng-container *ngIf="loader">
  <div class="loading"></div>
</ng-container>
